import { Card, Text } from "@mantine/core";
import { OtherAppealSituations } from "@/__generated__/graphql";
import CardButton from "@/components/CardButton/CardButton";

import styles from "./initial-referral-page.module.scss";

interface SpecialAppealSituationsCardProps {
  selectedSituations: OtherAppealSituations[];
  onToggleSituation: (situation: OtherAppealSituations) => void;
  disabled?: boolean;
}

export function SpecialAppealSituationsCard({
  selectedSituations,
  onToggleSituation,
  disabled = false,
}: SpecialAppealSituationsCardProps) {
  return (
    <Card className={styles.infoCard} padding="lg" radius="md" withBorder>
      <div className={styles.cardHeader}>
        <h2 className={styles.formHeader}>Special appeal situations</h2>
        <Text className={styles.optionalLabel} size="sm">
          Optional
        </Text>
      </div>
      <div className={styles.formSubheader}>
        <p className={styles.formSubheader__text}>
          Do any of these other appeal situations apply? Select all that apply
        </p>
      </div>

      <div className={styles.cardButtonGrid}>
        <CardButton
          title="Switched health plans"
          description="Patient is being asked by a new insurer to re-try and re-fail step therapy already completed, putting their health at risk"
          isSelected={selectedSituations.includes(
            OtherAppealSituations.SwitchedHealthPlans,
          )}
          onClick={() =>
            onToggleSituation(OtherAppealSituations.SwitchedHealthPlans)
          }
          disabled={disabled}
        />
        <CardButton
          title="Copay won't count"
          description="Patient is being told that 100% of their copay and/or care expense will not count towards their deductible or out-of-pocket maximum"
          isSelected={selectedSituations.includes(
            OtherAppealSituations.CopayDoesNotCount,
          )}
          onClick={() =>
            onToggleSituation(OtherAppealSituations.CopayDoesNotCount)
          }
          disabled={disabled}
        />
        <CardButton
          title="Extreme care delay"
          description="Patient has experienced a significant care delay or gap due to long response times and/or unjust denials, putting their health at risk"
          isSelected={selectedSituations.includes(
            OtherAppealSituations.ExtremeCareDelay,
          )}
          onClick={() =>
            onToggleSituation(OtherAppealSituations.ExtremeCareDelay)
          }
          disabled={disabled}
        />
        <CardButton
          title="Appeal period expired"
          description="The time the patient was given to appeal has expired, but they had special circumstances and would like to request an extension"
          isSelected={selectedSituations.includes(
            OtherAppealSituations.AppealPeriodExpired,
          )}
          onClick={() =>
            onToggleSituation(OtherAppealSituations.AppealPeriodExpired)
          }
          disabled={disabled}
        />
      </div>
    </Card>
  );
}
